import React, { Fragment, useState } from 'react';
import cn from 'classnames';
import {
  Button,
  QuantitySelector,
  Loading,
  Tooltip,
  PriceTagWithPromoMessage
} from '@insight/toolkit-react';
import { t } from '@insight/toolkit-utils';
import {
  ILISTVIEW,
  IPS_LOGGEDOUT_CTA,
  SHORT_TERM_LEASING_OPTION,
  DISPLAY_FINANCING_OFFERS_BUTTON,
  ADD_TO_CART_CATEGORY_TYPES,
  CONTRACT_LOADING_MESSAGE,
  CONTRACT_TIMED_OUT_MESSAGE,
  PRICE_LOADING_MESSAGE,
  PRICE_TIMED_OUT_MESSAGE,
} from '../../constants';
import ListItemPriceStock from './ListItemPriceStock';
import CalloutActions from './CalloutAction';
function CartActions({
  index,
  callForPrice,
  currency,
  isOnMobile,
  insightPrice,
  listPrice,
  webPrice,
  indexPrice,
  priceInfo,
  isIPSUserWithContract,
  isMultipleContract,
  isSingleContract,
  inclVatPrice,
  displayDiscount,
  priceLabel,
  view,
  product,
  onAddToCart,
  onViewSimilar,
  stockNumber,
  showPriceAndStock,
  unlimited,
  selectedContract,
  isSSELoading,
  isSSETimedOut,
  hasSSEPrice,
  listPriceInclVat,
  webPriceInclVat,
  isCallForPrice,
  hideLoggedOutPricing,
  isCCXProduct,
  gotoPDP,
  isLoggedOutIPS,
  isLoggedIn,
  setOpenLeasingModal,
  setSelectedProduct,
  manufacturerName
}) {
  const [quantity, setQuantity] = useState(1)
  const [loading, setLoading] = useState(false)
  const isListView = view === ILISTVIEW.list && !isOnMobile;
  const isGridView = view === ILISTVIEW.grid || isOnMobile;
  const isLoggedInOrIpsLoggedOut = (isLoggedIn || isLoggedOutIPS) && !isIPSUserWithContract;
  const isDisabledByPrice = isLoggedInOrIpsLoggedOut && !hasSSEPrice;
  const isAnyIPSUser = isIPSUserWithContract || isLoggedOutIPS
  const selectedContractName = selectedContract?.abbreviation || selectedContract?.contractName;
  const isLongContractName = selectedContractName?.length > 64;
  const hideATCOnIPS = isLoggedOutIPS && window.flags[IPS_LOGGEDOUT_CTA];
  const leasingPromo = product.leasingPromo;
  function getIsShortTermLeasingEnabled() {
    const flags = window.flags;
    const insight = window.Insight;
    const isAppleProduct = manufacturerName === 'APPLE';
    return (
      // Show short-term leasing to logged-out users (public offer).
      // Logged-in users must have DISPLAY_FINANCING_OFFERS_BUTTON permission to see this option.
      flags?.[SHORT_TERM_LEASING_OPTION] &&
      isAppleProduct &&
      insight?.userInformation?.UserType !== 'B2B' &&
      ['FPP', undefined].includes(insight?.userInformation?.partnerProgramName) &&
      (!insight?.isLoggedin || insight?.webGroupPermissions?.includes(DISPLAY_FINANCING_OFFERS_BUTTON))
    );
  }
  const isShortTermLeasingEnabled = getIsShortTermLeasingEnabled();

  const onAddToCartHandler = async () => {
    setLoading(true)
    try {
      await onAddToCart(quantity)
    } finally {
      setLoading(false)
    }
  }

  const onOpenLeasingModalHandler = () => {
    setSelectedProduct(product)
    setOpenLeasingModal(true)
  }

  return (
    <Fragment>
      {hideLoggedOutPricing ? (
        <CalloutActions isCallForPrice={isCallForPrice} categoryType={ADD_TO_CART_CATEGORY_TYPES.MAIN_SEARCH_RESULTS} />
      ) : (
        <div
          className={cn('c-cart-actions o-grid', {
            list: isListView,
            grid: isGridView,
            'o-grid--justify-right': isListView,
            'o-grid--justify-left': isGridView,
          })}
        >
          {
            // error handling and contract name for list view
            isListView && (
              <>
                <div className="o-grid c-truncate">
                  <div className="u-text-bold c-cart-actions__contract-name u-margin-bot-tiny o-grid--reverse">
                    {isSSELoading && !isMultipleContract && (
                      <div className="o-grid o-grid--center">
                        <div>{t(isAnyIPSUser ? CONTRACT_LOADING_MESSAGE : PRICE_LOADING_MESSAGE)}</div> &nbsp;
                        <div className="c-list-item__contract-loading-icon">
                          <Loading />
                        </div>
                      </div>
                    )}
                    {isSSETimedOut && !isMultipleContract && (
                      <span>{t(isAnyIPSUser ? CONTRACT_TIMED_OUT_MESSAGE : PRICE_TIMED_OUT_MESSAGE)}</span>
                    )}
                    {!callForPrice && priceInfo && !!selectedContract?.contractNumber && isLoggedOutIPS && (
                      <span>{selectedContract?.contractName}</span>
                    )}
                    {priceInfo &&
                      !callForPrice &&
                      (isSingleContract && !selectedContract?.contractNumber ? (
                        <span>{t('Open market')}</span>
                      ) : !isLoggedOutIPS ? (
                        <Tooltip
                          content={
                            selectedContract?.abbreviation ||
                            selectedContract?.contractName
                          }
                        >
                          <span
                            className={
                              isLongContractName ? 'c-text long-text' : 'c-text'
                            }
                            style={{ WebkitBoxOrient: 'vertical' }}
                          >
                            {selectedContract?.abbreviation ||
                              selectedContract?.contractName}
                          </span>
                        </Tooltip>
                      ) : null)}
                  </div>
                </div>
                {!isCCXProduct && (
                  <ListItemPriceStock
                    callForPrice={callForPrice}
                    currency={currency}
                    insightPrice={insightPrice}
                    listPrice={listPrice}
                    webPrice={webPrice}
                    indexPrice={indexPrice}
                    inclVatPrice={inclVatPrice}
                    displayDiscount={displayDiscount}
                    priceLabel={priceLabel}
                    stockNumber={stockNumber}
                    showPriceAndStock={showPriceAndStock}
                    unlimited={unlimited}
                    view={view}
                    isOnMobile={isOnMobile}
                    selectedContract={selectedContract}
                    priceInfo={priceInfo}
                    isIPSUserWithContract={isIPSUserWithContract}
                    isMultipleContract={isMultipleContract}
                    isSingleContract={isSingleContract}
                    isSSELoading={isSSELoading}
                    isSSETimedOut={isSSETimedOut}
                    listPriceInclVat={listPriceInclVat}
                    webPriceInclVat={webPriceInclVat}
                    isCCXProduct={isCCXProduct}
                  />
                )}
              </>
            )
          }
          {isShortTermLeasingEnabled && (
            <Fragment>
             <div className='c-list-item__product-details__leasing'>
              <span
                onClick={onOpenLeasingModalHandler}
                className=' c-list-item__product-details__leasing c-list-item__product-details__leasing-link'
              >
                {t('Financing offers available')}
              </span>
             </div>
              {leasingPromo && (
               <div className="c-list-item__product-details__leasing c-list-item__product-details__promo-message">
                   <PriceTagWithPromoMessage discount={leasingPromo.discount} promoMessage={t("leasing savings")}/>
               </div>
              )}
              </Fragment>)
          }
          {
            // add to cart button for list view  and grid view
          }
          {hideATCOnIPS ? (
            <div className="o-grid__item u-1/1">
              <CalloutActions isLoggedOutIPS={isLoggedOutIPS} categoryType={ADD_TO_CART_CATEGORY_TYPES.MAIN_SEARCH_RESULTS} />
            </div>
          ) : (
            <div className="c-cart-actions__action-group o-grid__item u-1/1">
              {!isOnMobile && callForPrice ? (
                <Button
                  className="c-button--block"
                  color={'secondary'}
                  size="small"
                  onClick={onViewSimilar}
                >
                  {t('View similar items')}
                </Button>
              ) : (
                <Fragment>
                  {!isCCXProduct || (isCCXProduct && isListView) ? (
                    <QuantitySelector
                      className={cn(
                        'c-cart-actions__action-group__qty-selector',
                        {
                          'c-cart-actions__action-group__qty-selector_invisible':
                            isCCXProduct && isListView,
                        }
                      )}
                      aria-label={
                        isCCXProduct && isListView ? '' : t('Quantity')
                      }
                      id={`quantity${index}`}
                      name={`quantity${index}`}
                      value={quantity}
                      isDisabled={
                        loading ||
                        callForPrice ||
                        isSSELoading ||
                        isSSETimedOut ||
                        isDisabledByPrice
                      }
                      min={1}
                      max={9999999999}
                      size="small"
                      onChange={(value) => setQuantity(parseInt(value))}
                    />
                  ) : null}
                  {isCCXProduct ? (
                    <div
                      className={cn('c-list-item__cart-actions o-grid__item', {
                        align: isListView,
                      })}
                    >
                      <Button
                        className="c-button--block c-cart-actions__button-add"
                        color={'primary'}
                        size="small"
                        onClick={gotoPDP}
                      >
                        {t('See more details')}
                      </Button>
                    </div>
                  ) : (
                    <Button
                      className="c-button--block c-cart-actions__button-add"
                      color={'primary'}
                      size="small"
                      isLoading={loading}
                      isDisabled={
                        callForPrice || isSSELoading || isSSETimedOut || isDisabledByPrice
                      }
                      onClick={onAddToCartHandler}
                    >
                      {t('Add to cart')}
                    </Button>
                  )}
                </Fragment>
              )}
            </div>
          )}
        </div>
      )}
    </Fragment>
  )
}

export default CartActions
